const defaultApiUrl = 'https://localhost:3000'
const configuredApiUrl = import.meta.env.VITE_API_URL

if (!configuredApiUrl) {
	console.warn(`VITE_API_URL is not set. Falling back to ${defaultApiUrl}`)
}

export const config = {
	apiURL: configuredApiUrl || defaultApiUrl,
	env: import.meta.env.VITE_ENVIRONMENT,
	okta: {
		issuer: import.meta.env.VITE_OKTA_ISSUER,
		clientId: import.meta.env.VITE_ADMIN_OKTA_CLIENT_ID,
	},
}
